import pkg from '../../../../../package.json';
import { type IHeaders } from './IRequestor';

const { version } = pkg;
const SOURCE = `vd ${version}`;

export const X_SOLINK_SOURCE = 'x-solink-source';

/**
 * Returns a string to be used as the `x-solink-source` header in a request.
 *
 * @param [description] - If provided, a unique searchable string which will
 * identify where in the code the request came from.
 */
export function sourceHeader(description?: string): string {
  if (description) {
    return `${SOURCE}; ${description}`;
  }
  return SOURCE;
}

/**
 * Like `sourceHeader`, but returns a headers object.
 */
export function sourceHeaders(description?: string): IHeaders {
  return {
    [X_SOLINK_SOURCE]: sourceHeader(description),
  };
}
